import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { RefreshCw, Plus, Trash2 } from "lucide-react";
import { format, parseISO } from "date-fns";
import { tr } from "date-fns/locale";

const ResmiTatillerSection = ({
  // Data
  holidays,
  isBasicRole,
  loading,
  canEditHolidays = true, // false = gölge admin, sadece görüntüleme
  // Actions
  onLoadDefaultHolidays,
  onAddHolidayClick,
  onDeleteHoliday
}) => {
  const showAddDelete = !isBasicRole && canEditHolidays;
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Resmi ve İdari Tatiller</h3>
        {/* Tatil ekleme butonları - sadece amir rolleri (gölge admin hariç) */}
        {showAddDelete && (
          <div className="flex gap-2">
            <Button variant="outline" onClick={onLoadDefaultHolidays} disabled={loading}>
              <RefreshCw className="h-4 w-4 mr-2" />
              Türkiye Tatillerini Yükle
            </Button>
            <Button onClick={onAddHolidayClick}>
              <Plus className="h-4 w-4 mr-2" />
              Tatil Ekle
            </Button>
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {holidays.sort((a, b) => a.date.localeCompare(b.date)).map(holiday => (
          <Card key={holiday.id} className={
            holiday.holiday_type === 'idari_tatil' 
              ? 'border-purple-300 bg-purple-50' 
              : 'border-red-300 bg-red-50'
          }>
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <h4 className="font-semibold">{holiday.name}</h4>
                    <Badge variant="outline" className={
                      holiday.holiday_type === 'idari_tatil'
                        ? 'bg-purple-100 text-purple-700'
                        : 'bg-red-100 text-red-700'
                    }>
                      {holiday.holiday_type === 'idari_tatil' ? 'İdari' : 'Resmi'}
                    </Badge>
                  </div>
                  <p className="text-sm text-gray-500">
                    {format(parseISO(holiday.date), 'd MMMM yyyy, EEEE', { locale: tr })}
                  </p>
                  {holiday.description && (
                    <p className="text-xs text-gray-400 mt-1">{holiday.description}</p>
                  )}
                  {(holiday.created_by_name || holiday.updated_by_name) && (
                    <p className="text-xs text-gray-500 mt-1">
                      {holiday.updated_by_name
                        ? `Son güncelleyen: ${holiday.updated_by_name}`
                        : `Ekleyen: ${holiday.created_by_name}`}
                    </p>
                  )}
                  {holiday.is_recurring && (
                    <Badge variant="outline" className="mt-1 text-xs">Her yıl tekrarlar</Badge>
                  )}
                </div>
                {/* Tatil silme butonu - sadece amir rolleri (gölge admin hariç) */}
                {showAddDelete && (
                  <Button 
                    variant="ghost" 
                    size="sm"
                    className="hover:bg-red-100"
                    onClick={() => onDeleteHoliday('holiday', holiday.id, holiday.name)}
                  >
                    <Trash2 className="h-4 w-4 text-red-500" />
                  </Button>
                )}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default ResmiTatillerSection;
